/** Shared formatting helpers. */

/** Euro, rounded, Italian thousands separators. e.g. fmtEur(8745300) → "€ 8.745.300". */
export function fmtEur(n: number): string {
  return "€ " + Math.round(n).toLocaleString("it-IT");
}
